var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Col } from "react-bootstrap";
import Card from "../../../Layout/Card";
import media from "../../../global/media";
var StyledCol = styled(Col)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", " {\n    ", "\n  }\n"], ["\n  ",
    "\n  ", " {\n    ",
    "\n  }\n"])), media.phoneLandscape(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-right: 0;\n    padding-left: 0;\n  "], ["\n    padding-right: 0;\n    padding-left: 0;\n  "]))), Card, media.phoneLandscape(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))));
export default StyledCol;
var templateObject_1, templateObject_2, templateObject_3;
